import { useEffect, useState } from "react";
import useAxios from "../../../../../../../hooks/useAxios";
import { CLIENT_PLATFORMS_SELECTABLE } from "../../../../../../../shared/lib/apiEndpointsResolver";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";
import UpdatePlatformClientMappingForm from "./UpdatePlatformClientMappingForm";
import { catchFunction } from "../../../../../../../shared/lib/utils";

const UpdatePlatformClientMappingDialog = ({
  id,
  platformMapping,
  onSubmitHandler,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const axios = useAxios();

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  useEffect(() => {
    axios
      .get(CLIENT_PLATFORMS_SELECTABLE(id))
      .then((response) => setPlatforms(response.data))
      .catch(catchFunction);
  }, [id]);

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.detail.tabs.platformMappings.updateForm.title"
      description="clients.detail.tabs.platformMappings.updateForm.description"
      content={
        <UpdatePlatformClientMappingForm
          platformMapping={platformMapping}
          platforms={platforms}
          onSubmitHandler={onSubmit}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdatePlatformClientMappingDialog;
